import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import InvestingEntityType from 'src/app/dashboard/models/InvestingEntityType.enum';

@Component({
  selector: 'lp-share-approve',
  templateUrl: './lp-share-approve.component.html',
  styleUrls: ['lp-share-approve.component.scss'],
})
export class SelectAndAgreeComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      options: Array<{
        id: string;
        name: string;
        email: string;
        investingEntityType: InvestingEntityType;
      }>;
      title: string;
      confirmButton: string;
      checkboxLabel: string;
      checkboxDisabled: true;
      dropdownPlaceholder: string;
    }
  ) {}

  selectedItem = new FormControl();
  agreed: boolean = true;

  ngOnInit(): void {
    if (this.data?.options?.length === 1) {
      this.selectedItem.setValue(this.data?.options[0]);
    }
  }
}
